import { gql } from '@apollo/client';

export const FILTERED_INTERVENTIONS = gql`
  query FilteredInterventions($input: FilterInterventions!) {
    interventions: filteredInterventions(input: $input) {
      id
      beneficiaries {
        id
        name
      }
      beneficiaryCount
      reportersCount
      fromDate
      grades {
        id
        value
      }
      institutionsCount
      institutions {
        id
        institution {
          id
          name
        }
      }
      isInternal
      name
      otherBeneficiaries {
        id
        name
      }
      otherTreatmentGroups {
        id
        name
      }
      peopleProfiles {
        id
        peopleProfile {
          id
          name
        }
      }
      programme {
        id
        name
      }
      toDate
      treatmentGroup {
        id
        name
      }
    }
  }
`;
